// Core
import React from 'react'

// Library
import clsx from 'clsx'

// Styles
import classes from 'components/Onboarding/Disclaimer/Disclaimer.module.scss'

export default function SignupDisclaimer() {
  return (
    <div className={clsx(classes.container)}>
      <span className={clsx(classes.copy)}>
        By creating your account you agree to the 
        {' '}
        <a href="https://edee.ai/termsofservice" rel="noreferrer" target="_blank" data-cy="terms">
          Terms of Service
        </a>
        {' '}
        and
        {' '}
        <a href="https://edee.ai/privacy" rel="noreferrer" target="_blank" data-cy="privacy">
          Privacy Policy
        </a>
      </span>
    </div>
  )
}
